import React from 'react';
import PageLinks from '../atom/PageLinks';

import styles from './Nav.module.scss';

const Nav: React.FC = () => (
  <nav className={styles.nav}>
    <PageLinks setPosition='nav' />
  </nav>
);

export default Nav;
